import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '../layouts/MainLayout.vue'
import TitlesView from '../views/TitlesView.vue'
import CertificatesView from '../views/CertificatesView.vue'
import InstitutionView from '../views/InstitutionView.vue'
import LoginLayout from '@/layouts/LoginLayout.vue'
import { auth, database } from '@/firebase/config'
import { get, ref } from 'firebase/database'
import AccountView from '@/views/AccountView.vue'
import AdminLayout from '@/layouts/AdminLayout.vue'
import DashboardView from '@/views/DashboardView.vue'
import TransaccionesView from '@/views/TransaccionesView.vue'
import EstadisticasView from '@/views/EstadisticasView.vue'
import RegistroView from '@/views/RegistroView.vue'
import { EUserRole } from '@shared/types/enums'
import AmountDocumentsView from '@/components/admin/AmountDocuments.vue'
import InstitutionAdminView from '@/views/InstitutionAdminView.vue'
import MantenimientoView from '@/views/MantenimientoView.vue'
import PagosView from '@/views/PagosView.vue'
import FinanzasView from '@/views/FinanzasView.vue'
import FacturasAdminView from '@/views/FacturasView.vue'
import DesactivacionView from '@/views/DesactivacionView.vue'
import ExpiracionView from '@/views/ExpiracionView.vue'
import ValidadorPUIView from '@/views/ValidadorPUIView.vue'
import Anexo9View from '@/views/Anexo9View.vue'
import PlanEstudiosView from '@/components/admin/update/PlanEstudios.vue'
import CreditosView from '@/components/admin/update/Creditos.vue'
import ResponsablesView from '@/components/admin/update/Responsables.vue'
import ConfiguracionView from '@/components/admin/update/Configuracion.vue'
import AsignaturasView from '@/components/admin/update/Asignaturas.vue'
const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: '/',
			component: MainLayout,
			meta: { requiresAuth: true },
			children: [
				{
					path: '',
					redirect: '/degrees'
				},
				{
					path: 'titles',
					redirect: '/degrees'
				},
				{
					path: 'degrees',
					name: 'Títulos',
					component: TitlesView
				},
				{
					path: 'certificates',
					name: 'Certificados',
					component: CertificatesView
				},
				{
					path: 'institution',
					name: 'Institución',
					component: InstitutionView
				},
				{
					path: 'finanzas',
					name: 'Finanzas',
					component: FinanzasView
				},
				{
					path: 'validadorPUI',
					name: 'Validador PUI',
					component: ValidadorPUIView
				},
				{
					path: 'anexo9',
					name: 'Anexo 9',
					component: Anexo9View
				},
				{
					path: 'cuenta',
					name: 'Cuenta',
					component: AccountView
				}
			]
		},
		{
			path: '/admin',
			component: AdminLayout,
			meta: { requiresAuth: true, requiresAdmin: true },
			children: [
				{
					path: 'bitacora',
					name: 'Bitacora',
					component: DashboardView
				},
				{
					path: 'transacciones',
					name: 'Transacciones',
					component: TransaccionesView
				},
				{
					path: 'estadisticas',
					name: 'Estadísticas',
					component: EstadisticasView
				},
				{
					path: 'registro',
					name: 'Registro',
					component: RegistroView
				},
				{
					path: 'actualizar',
					name: 'Actualizar',
					redirect: '/admin/actualizar/plan-estudios',
					children: [
						{
							path: 'plan-estudios',
							name: 'Plan de estudios',
							component: PlanEstudiosView
						},
						{
							path: 'creditos',
							name: 'Créditos',
							component: CreditosView
						},
						{
							path: 'responsables',
							name: 'Responsables',
							component: ResponsablesView
						},
						{
							path: 'configuracion',
							name: 'Configuración',
							component: ConfiguracionView
						},
						{
							path: 'asignaturas',
							name: 'Asignaturas',
							component: AsignaturasView
						}
					]
				},
				{
					path: 'contabilizar',
					name: 'Contabilizar',
					component: AmountDocumentsView
				},
				{
					path: 'institutions',
					name: 'Instituciones',
					component: InstitutionAdminView
				},
				{
					path: 'mantenimiento',
					name: 'Mantenimiento',
					component: MantenimientoView
				},
				{
					path: 'pagos',
					name: 'Pagos',
					component: PagosView
				},
				{
					path: 'facturas',
					name: 'Facturas',
					component: FacturasAdminView
				},
				{
					path: 'desactivacion',
					name: 'Desactivación',
					component: DesactivacionView
				},
				{
					path: 'expiracion',
					name: 'Expiración',
					component: ExpiracionView
				},
				{
					path: '',
					redirect: '/admin/bitacora'
				}
			]
		},
		{
			path: '/login',
			component: LoginLayout,
			meta: { requiresAuth: false },
			children: [
				{
					path: '',
					name: 'Login',
					component: () => import('@/views/Login.vue')
				}
			]
		}
	]
})

// Navigation guard
router.beforeEach(async (to, _, next) => {
	const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
	const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)

	// Verificar si hay un usuario autenticado en Firebase
	const currentUser = auth.currentUser

	// Si la ruta requiere autenticación y no hay usuario autenticado
	if (requiresAuth && !currentUser) {
		next('/login')
		return
	}

	// Si la ruta es login y hay usuario autenticado
	if (to.path === '/login' && currentUser) {
		next('/')
		return
	}

	// Si la ruta requiere admin, verificar permisos
	if (requiresAdmin && currentUser) {
		try {
			// Obtener datos del usuario desde Firebase Realtime Database
			const userSnapshot = await get(ref(database, `users/${currentUser.uid}`))
			const userData = userSnapshot.val()
			// Verificar si el usuario tiene permisos de admin
			// Puede ser 'admin', 'isAdmin', 'role: admin', etc.
			const isAdmin = userData?.role?.tipoRole === EUserRole.ADMINISTRADOR

			if (!isAdmin) {
				// Usuario no es admin, redirigir a la página principal
				next('/')
				return
			}
		} catch (error) {
			console.error('Error verificando permisos de admin:', error)
			// En caso de error, redirigir a la página principal por seguridad
			next('/')
			return
		}
	}

	// En cualquier otro caso, permitir la navegación
	next()
})

export default router
